import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ICity, EmptyCity } from "./City";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { IStateMastDropdown } from "../../../models/IDropdown";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";

const schema = yup.object({
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city_Name: yup.string().required("City Name is required*"),
    description: yup.string().nullable()
});

interface Iprops {
    singleData: ICity,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [states, setStates] = useState<Array<IStateMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ICity>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const saveToDB = async (body: ICity) => {
        const method = props.singleData.city_ID ? "PUT" : "POST";
        const message = props.singleData.city_ID ? "Updated Successfully" : "Added Successfully";

        body.state_ID = body.state?.state_ID;
        delete body.state;

        const response = await Fetch("City_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyCity);
    }

    function onSubmit(data: ICity) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit City" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdownInput required column={2} completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVInput required column={2} label="City Name" control={control} name="city_Name" error={errors.city_Name?.message} />
                <JVInput column={1} label="Description" control={control} name="description" error={errors.description?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
